import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'logzy-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.scss']
})
export class UserDetailsComponent implements OnInit {
  bindCompany = new BehaviorSubject(null)
  bindNewCompany = new BehaviorSubject(null)

  canvas: string = "Canvas";
  open1: string = "sidepanel";

  constructor() { }

  ngOnInit(): void {
  }

  openEdit(data) {
    this.open1 = " sidepanel slidepanelOpen ";
    this.canvas = "Canvas setCanvas";
    setTimeout(() => {
      this.bindCompany.next(data);
    }, 50);
  }

  closeEdit() {
    this.open1 = " sidepanel ";
    this.canvas = "Canvas ";
    this.bindCompany.next(null);
  }

  bindAddedCompany(event) {
    this.open1 = " sidepanel ";
    this.canvas = "Canvas ";
    this.bindNewCompany.next(event);
  }

}
